<div class="{{colorClasses()}}">
  @if (loading()) {
    <mat-spinner class="spinner-{{color()}}" [diameter]="20"></mat-spinner>
  } @else {
    @if (icon()) {
      <mat-icon class="icon">{{ icon() }}</mat-icon>
    }
    @if (text()) {
      <span class="button linebreak">{{ text() }}</span>
    }
    @if (iconRight()) {
      <mat-icon class="icon">{{ iconRight() }}</mat-icon>
    }
  }
</div>
